import { Component, Inject, OnInit } from '@angular/core';
import {
	UntypedFormBuilder,
	UntypedFormGroup,
	Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import moment from 'moment';

@Component({
	selector: 'app-delete-dependent-modal',
	styleUrls: ['./delete-dependent-modal.component.scss'],
	templateUrl: './delete-dependent-modal.component.html',
})
export class DeleteDependentModalComponent implements OnInit {
	form: UntypedFormGroup;
	name?: string;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: {
			name: string;
		},
		public dialogRef: MatDialogRef<DeleteDependentModalComponent>,
		private readonly formBuilder: UntypedFormBuilder,
	) {
		this.form = this.formBuilder.group({
			dateOfExclusion: [null, [Validators.required]],
			name: [null],
		});
	}

	closeModal() {
		this.dialogRef.close();
	}

	deleteDependent(): void {
		const dateOfExclusion = moment(
			this.form.get('dateOfExclusion')?.value,
		).format('YYYY-MM-DD hh:mm:ssZZ');
		this.dialogRef.close(dateOfExclusion);
	}

	ngOnInit(): void {
		this.name = this.data.name;
		const name = this.form.get('name');
		name?.setValue(this.data.name);
		name?.disable();
	}
}
